import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { supabase } from "../supabaseClient";

const STAFF_AGREEMENT_ROLE_IDS = [
  "1499958587479429130",
  "1499913787833319566",
  "1499918895048294400",
  "1502218902770548796",
];

export default function StaffAgreementRoute({ children }) {
  const { session } = useAuth();
  const [checked, setChecked] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  const discordId =
    session?.user?.identities?.find(i => i.provider === "discord")?.id ||
    session?.user?.user_metadata?.provider_id;

  useEffect(() => {
    if (session === undefined) return;

    if (!session) {
      setChecked(true);
      setHasAccess(false);
      return;
    }

    fetch("/api/check-staff-role", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        discord_id: discordId,
        role_ids: STAFF_AGREEMENT_ROLE_IDS,
        secret: process.env.REACT_APP_DM_WEBHOOK_SECRET,
      }),
    })
      .then(r => r.json())
      .then(data => {
        setHasAccess(!!data.hasRole);
        setChecked(true);
      })
      .catch(() => {
        setHasAccess(false);
        setChecked(true);
      });
  }, [session, discordId]);

  if (session === undefined || !checked) return null;

  if (!session) return <Navigate to="/login" replace />;

  if (!hasAccess) {
    supabase.auth.signOut();
    return <Navigate to="/login?error=unauthorized" replace />;
  }

  return children;
}
